(function () {
  if (window._dsUpsellClickInit) return;
  window._dsUpsellClickInit = true;

  /**
   * Reads bundle properties from the LIVE liquidAjaxCart cart state.
   * This is intentionally NOT read from data-bundle-props (a Liquid-render-time attribute)
   * because LAC section re-renders only update innerHTML, not element attributes — making
   * data-bundle-props potentially stale after cart updates.
   */
  function getBundlePropsFromCart() {
    var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!cart || !cart.items) return null;

    var bundleItems = cart.items.filter(function (item) {
      return item.properties && item.properties._set_id != null && item.properties._set_id !== '';
    });
    if (bundleItems.length === 0) return null;

    var firstSetId = String(bundleItems[0].properties._set_id);
    var allSame = bundleItems.every(function (item) {
      return String(item.properties._set_id) === firstSetId;
    });
    if (!allSame) return null;

    var ref = bundleItems[0].properties;
    return {
      '_set_id':       String(ref._set_id),
      '_paket':        ref._paket        || '',
      '_url':          ref._url          || '',
      '_set_image':    ref._set_image    || '',
      '_selling_plan': ref._selling_plan || ''
    };
  }

  /**
   * Liefert den Namen des Selling-Plans, unter dem das aktuelle Bundle läuft
   * (z. B. "Zustellung alle 7 Tage"), oder null für Einmalkauf-Carts.
   * Quelle ist `selling_plan_allocation.selling_plan.name` vom ersten Bundle-Item,
   * weil die `_selling_plan`-Property am Cart-Line-Item leer bleibt.
   */
  function getBundleSellingPlanName() {
    var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it && it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
        return it.selling_plan_allocation.selling_plan.name || null;
      }
    }
    return null;
  }

  // Fuzzy-Match über Frequenz (Tage/Wochen/Monate), analog ds-product-add-bundle.js.
  // Erlaubt, Plans zu matchen, deren Name leicht abweicht, solange die
  // Lieferfrequenz identisch ist.
  function normalizePlanName(name) {
    if (!name) return null;
    var s = String(name).toLowerCase();
    var m = s.match(/(\d+)/);
    var count = m ? parseInt(m[1], 10) : null;
    var unit = null;
    if (/tag|tage|day|days/.test(s)) unit = 'd';
    else if (/woche|wochen|week|weeks/.test(s)) unit = 'w';
    else if (/monat|monate|month|months/.test(s)) unit = 'm';
    else if (/jahr|jahre|year|years/.test(s)) unit = 'y';
    return (count && unit) ? { count: count, unit: unit } : null;
  }
  function toDays(norm) {
    if (!norm) return null;
    if (norm.unit === 'd') return norm.count;
    if (norm.unit === 'w') return norm.count * 7;
    if (norm.unit === 'm') return norm.count * 30;
    if (norm.unit === 'y') return norm.count * 365;
    return null;
  }

  var _productCache = {};
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (_productCache[handle]) return Promise.resolve(_productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { _productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function resolveSellingPlanId(product, targetName) {
    if (!product || !product.selling_plan_groups || !targetName) return null;
    var plans = [];
    product.selling_plan_groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) { plans.push(p); });
    });
    // 1) Exakter Name-Match
    var target = targetName.trim();
    var match = plans.find(function (p) { return (p.name || '').trim() === target; });
    if (match) return match.id;
    // 2) Fuzzy über Frequenz
    var targetDays = toDays(normalizePlanName(target));
    if (targetDays != null) {
      match = plans.find(function (p) {
        return toDays(normalizePlanName(p.name)) === targetDays;
      });
      if (match) return match.id;
    }
    return null;
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    // Icon-Buttons (Redesign) behalten ihr SVG und zeigen den Ladezustand per Klasse
    var isIconButton = btn.hasAttribute('data-upsell-icon');
    var originalLabel = isIconButton ? btn.innerHTML : btn.textContent;
    if (isIconButton) {
      btn.classList.add('is-loading');
    } else {
      btn.textContent = '...';
    }

    var card = btn.closest('.ds-cart-upsell__item, [data-upsell-card]');
    var bundleProps = getBundlePropsFromCart();
    var bundlePlanName = getBundleSellingPlanName();

    function onSuccess() { if (card) card.remove(); }
    function restoreLabel() {
      btn.removeAttribute('aria-busy');
      if (isIconButton) {
        btn.classList.remove('is-loading');
        btn.innerHTML = originalLabel;
      } else {
        btn.textContent = originalLabel;
      }
    }
    function onError() {
      btn.disabled = false;
      restoreLabel();
    }

    // Hard-Lock: Ist der Cart ein Abo, muss der Upsell denselben Selling-Plan
    // bekommen. Einen Einmalkauf ins Abo zu mischen würde die Exklusivität
    // brechen und Shopifys Subscription-Checkout in Konflikte bringen.
    var sellingPlanId = null;
    if (bundlePlanName) {
      var handle = btn.dataset.handle;
      var product = await fetchProduct(handle);
      sellingPlanId = resolveSellingPlanId(product, bundlePlanName);
      if (!sellingPlanId) {
        console.warn('[DS Upsell] Kein passender Selling-Plan für Upsell-Produkt', handle, '→ Add abgebrochen.');
        btn.removeAttribute('aria-busy');
        if (isIconButton) {
          btn.classList.remove('is-loading');
        } else {
          btn.textContent = 'Nicht als Abo verfügbar';
        }
        btn.disabled = true;
        setTimeout(function () {
          // Reset-Text nach 2.5s, damit der Button nicht dauerhaft lahmgelegt ist
          restoreLabel();
        }, 2500);
        return;
      }
    }

    if (typeof liquidAjaxCart !== 'undefined') {
      var fd = new FormData();
      fd.append('id', btn.dataset.variantId);
      fd.append('quantity', '1');
      if (sellingPlanId) {
        fd.append('selling_plan', String(sellingPlanId));
      }
      if (bundleProps) {
        Object.keys(bundleProps).forEach(function (k) {
          fd.append('properties[' + k + ']', bundleProps[k]);
        });
      }
      liquidAjaxCart.add(fd, {
        lastCallback: function (state) {
          state.responseData && state.responseData.ok ? onSuccess() : onError();
        }
      });
    } else {
      var body = { id: Number(btn.dataset.variantId), quantity: 1 };
      if (sellingPlanId) body.selling_plan = sellingPlanId;
      if (bundleProps) body.properties = bundleProps;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        r.ok ? onSuccess() : onError();
      }).catch(onError);
    }
  });
})();
